import React, { useContext, useEffect, useState } from "react";

import "./stylesSportsbook.css";
import Layout from "../CommonComponents/Layout/Layout";

import AppContext from "../../context/AppContext";
import { KPI_CARD_BACKGROUND, SIDER_TABS } from "../../utils/Constants";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete/CustomAutoComplete";
import CustomDatePicker from "../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";
import { ChevronDown, ChevronUp, Filter } from "react-feather";
import { Select, Space, Statistic } from "antd";
import CountUp from "react-countup";
import KpiCard from "../CommonComponents/Dashboard/KpiCard/KpiCard";
import ProviderPerformance from "./ProviderPerformance/ProviderPerformance";

function Sportsbook() {
  const { setActiveSidebarTab } = useContext(AppContext);

  const todayRange = [dayjs(), dayjs()];
  const tabs = ["Sportsbook KPI"];

  const [activeTab, setActiveTab] = useState("Sportsbook KPI");
  const [isApiRunning, setIsApiRunning] = useState(true);
  const [showExtraFilters, setShowExtraFilters] = useState(true);
    const [sportsBookDates, setSportsBookDates] =
      useState(todayRange);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.SPORTSBOOK, "Sportsbook");
  }, [setActiveSidebarTab]);

  useEffect(() => {
    setIsApiRunning(true);
    setTimeout(() => {
      setIsApiRunning(false);
    }, 2000);
  }, []);

  const provider = [
    {
      value: "BGaming",
      label: "BGaming",
    },
    {
      value: "Booming",
      label: "Booming",
    },
    {
      value: "IMoon",
      label: "IMoon",
    },
    {
      value: "OddsChecker",
      label: "OddsChecker",
    },
    {
      value: "Action Network",
      label: "Action Network",
    },
    {
      value: "BetQL",
      label: "BetQL",
    },
  ];

  const sport = [
    {
      value: "Football",
      label: "Football",
    },
    {
      value: "Basketball",
      label: "Basketball",
    },
    {
      value: "Tennis",
      label: "Tennis",
    },
  ];

  const league = [
    {
      value: "Premier League",
      label: "Premier League",
    },
    {
      value: "La Liga",
      label: "La Liga",
    },
    {
      value: "Serie A",
      label: "Serie A",
    },
  ];

  const match = [
    {
      value: "Match 1",
      label: "Match 1",
    },
    {
      value: "Match 2",
      label: "Match 2",
    },
    {
      value: "Match 3",
      label: "Match 3",
    },
  ];

  return (
    <Layout>
      <div className="sportsbook-container">
        <div className="sportsbook">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Sportsbook</p>
              </div>
              <CustomDatePicker
                getData={() => {}}
                dates={sportsBookDates}
                setDates={setSportsBookDates}
                showPresets={true}
              />
            </div>
            <div className="dashboard-tabs">
              {tabs.map((tab) => (
                <button
                  className={activeTab === tab ? "active" : null}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="sportsbook-content">
              <div className="sportsbook-content-header">
                <div className="sportsbook-autocomplete-container">
                  <CustomAutoComplete
                    placeholder="Search"
                    allOptions={[
                      {
                        label: "Option 1",
                        value: "Option 1",
                      },
                      {
                        label: "Option 2",
                        value: "Option 2",
                      },
                      { label: "Option 3", value: "Option 3" },
                      { label: "Option 4", value: "Option 4" },
                      {
                        label: "Option 5",
                        value: "Option 5",
                      },
                      { label: "Option 6", value: "Option 6" },
                    ]}
                    handleChange={() => {}}
                    clearOptions={() => {}}
                  />
                  <div className="divider"></div>
                  <div
                    className="filter-buttons"
                    onClick={() => setShowExtraFilters(!showExtraFilters)}
                  >
                    <Filter className="filter-icon" />
                    {showExtraFilters ? (
                      <ChevronUp className="filter-icon" />
                    ) : (
                      <ChevronDown className="filter-icon" />
                    )}
                  </div>
                </div>
              </div>
              <div
                className="sportsbook-selectors"
                style={{ display: showExtraFilters ? "flex" : "none" }}
              >
                <div className="sportsbook-selector">
                  <span>Provider</span>
                  <Select
                    mode="multiple"
                    placeholder="Not Selected"
                    onChange={() => {}}
                    options={provider}
                  />
                </div>
                <div className="sportsbook-selector">
                  <span>Sport</span>
                  <Select
                    mode="multiple"
                    placeholder="Not Selected"
                    onChange={() => {}}
                    options={sport}
                  />
                </div>
                <div className="sportsbook-selector">
                  <span>League</span>
                  <Select
                    mode="multiple"
                    placeholder="Not Selected"
                    onChange={() => {}}
                    options={league}
                  />
                </div>
                <div className="sportsbook-selector">
                  <span>Match</span>
                  <Select
                    mode="multiple"
                    placeholder="Not Selected"
                    onChange={() => {}}
                    options={match}
                  />
                </div>
              </div>
              <div
                className="sportsbook-selector-action-buttons"
                style={{ display: showExtraFilters ? "flex" : "none" }}
              >
                <button className="clear">Clear Filters</button>
                <button className="apply">Apply</button>
              </div>
              <div className="sportsbook-kpis">
                <div className="row">
                  <div className="kpi-cards-top-body">
                    <div className="left-content">
                      <KpiCard
                        isApiRunning={isApiRunning}
                        title="PROFIT & LOSS"
                        value={2500}
                        hugeValue={false}
                        percentage={12}
                        backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
                      />

                      <KpiCard
                        isApiRunning={isApiRunning}
                        title="MARGIN"
                        value={5.61}
                        hugeValue={false}
                        percentage={50}
                        backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
                      />
                      <KpiCard
                        isApiRunning={isApiRunning}
                        title="CASH OUT PROFIT & LOSS"
                        value={3750}
                        hugeValue={false}
                        percentage={50}
                        backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
                      />
                    </div>

                    <div className="right-content">
                      <KpiCard
                        isApiRunning={isApiRunning}
                        title="TURNOVER"
                        value={3750}
                        hugeValue={true}
                        percentage={20}
                        backgroundColor={KPI_CARD_BACKGROUND.TRASNPARENT}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <ProviderPerformance
                    isApiRunning={isApiRunning}
                    title={null}
                    showBottomKpis={false}
                  />
                </div>
                <div className="row bg-transparent p-0">
                  <KpiCard
                    isApiRunning={isApiRunning}
                    title="TOTAL BETS"
                    value={100000}
                    hugeValue={false}
                    percentage={3}
                    backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
                  />{" "}
                  <KpiCard
                    isApiRunning={isApiRunning}
                    title="AVG BET AMOUNT"
                    value={100}
                    hugeValue={false}
                    percentage={-5}
                    backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
                  />{" "}
                  <KpiCard
                    isApiRunning={isApiRunning}
                    title="PLAYERS ENGAGED"
                    value={27200}
                    hugeValue={false}
                    percentage={-80}
                    backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
                  />
                </div>
                <div className="row">
                  <ProviderPerformance
                    isApiRunning={isApiRunning}
                    title="SportRadar Performance"
                  />
                </div>
                <div className="row">
                  <ProviderPerformance
                    isApiRunning={isApiRunning}
                    title="Oddin Performance"
                  />
                </div>
                <div className="row">
                  <ProviderPerformance
                    isApiRunning={isApiRunning}
                    title="PropCity Performance"
                  />
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </Layout>
  );
}

export default Sportsbook;
